import { defaultLetterSpacing, defaultLineHeight } from '../constants/tokens/typography-tokens';

export const postprocessTypographyTokens = (typographyTokens: any) => {
  const defaultProperties = [
    {
      key: 'lineHeight',
      value: defaultLineHeight
    },
    {
      key: 'letterSpacing',
      value: defaultLetterSpacing
    }
  ];
  defaultProperties.forEach(defaultProperty => {
    for (const [tokenName, tokenDeclarations] of Object.entries(typographyTokens)) {
      if (!Object.keys(tokenDeclarations as any).some(cssProp => cssProp === defaultProperty.key)) {
        typographyTokens[tokenName][defaultProperty.key] = defaultProperty.value;
      }
    }
  });
  return typographyTokens;
};
